import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { BottomTabBar } from '@/components/layout/BottomTabBar'
import { getCurrentAcademicYear, SCHOOL_NAME } from '@krudream/shared'

export function SettingsPage() {
  const navigate = useNavigate()
  const { teacher, logout } = useAuth()
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <header className="bg-white px-4 py-3 shadow-sm">
        <div className="mx-auto max-w-lg">
          <h1 className="text-lg font-bold text-gray-900">ตั้งค่า</h1>
        </div>
      </header>

      <main className="mx-auto max-w-lg px-4 py-4 space-y-4">
        {/* Profile card */}
        <div className="rounded-lg bg-white p-4 shadow-sm">
          <h2 className="mb-3 text-sm font-semibold text-gray-500">ข้อมูลครู</h2>
          <div className="space-y-2">
            <InfoRow label="ชื่อ" value={teacher?.displayName || '-'} />
            <InfoRow label="บทบาท" value={teacher?.role === 'head_teacher' ? 'ครูประจำชั้น' : 'ผู้ช่วย'} />
            <InfoRow label="โรงเรียน" value={SCHOOL_NAME} />
            <InfoRow label="ปีการศึกษา" value={String(getCurrentAcademicYear())} />
          </div>
        </div>

        {/* Quick links */}
        <div className="rounded-lg bg-white shadow-sm">
          <h2 className="px-4 pt-4 text-sm font-semibold text-gray-500">เมนู</h2>
          <nav className="py-2">
            <MenuLink label="ตรวจสอบผู้ปกครอง (KYC)" onClick={() => navigate('/kyc')} />
            <MenuLink label="นำเข้ารายชื่อ CSV" onClick={() => navigate('/students/import')} />
            <MenuLink label="แก้ไขเช็คชื่อย้อนหลัง" onClick={() => {
              const today = new Date().toISOString().split('T')[0]
              navigate(`/attendance/${today}/edit`)
            }} />
          </nav>
        </div>

        {/* Logout */}
        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="w-full rounded-lg border border-red-200 bg-white py-3 text-sm font-medium text-red-600 shadow-sm"
        >
          ออกจากระบบ
        </button>

        {/* Version */}
        <p className="text-center text-xs text-gray-300">ครูดรีม v1.0.0</p>
      </main>

      {/* Logout confirmation */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-sm rounded-xl bg-white p-5 shadow-xl">
            <h3 className="text-base font-bold text-gray-900">ออกจากระบบ</h3>
            <p className="mt-2 text-sm text-gray-600">ต้องการออกจากระบบใช่หรือไม่?</p>
            <div className="mt-4 flex gap-2">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="flex-1 rounded-lg border border-gray-200 py-2.5 text-sm font-medium text-gray-600"
              >
                ยกเลิก
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 rounded-lg bg-red-600 py-2.5 text-sm font-semibold text-white"
              >
                ออกจากระบบ
              </button>
            </div>
          </div>
        </div>
      )}

      <BottomTabBar active="more" />
    </div>
  )
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between text-sm">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium text-gray-900">{value}</span>
    </div>
  )
}

function MenuLink({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center justify-between px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-50"
    >
      <span>{label}</span>
      <span className="text-gray-300">▸</span>
    </button>
  )
}
